module.exports = "<body data-open=\"click\" data-menu=\"horizontal-menu\" data-col=\"1-column\"\r\n  class=\"horizontal-layout horizontal-menu 1-column bg-lighten-2 menu-expanded fixed-navbar anonymous-cmp\">\r\n  <div class=\"app-content container center-layout mt-2\">\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n</body>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/anonymous/anonymous.component.html
// module id = ../../../../../src/app/anonymous/anonymous.component.html
// module chunks = main